/* =====================================================================
   Reef Lagoon · PNG Expeditions — page behaviours
   Loaded (deferred) ONLY when template.suffix == 'png-expeditions'.
     1. Scroll-reveal (IntersectionObserver, staggered, reduced-motion gate,
        idempotent, re-init on shopify:section:load)
     2. Season departure card → prefill the enquiry select + smooth-scroll
     3. ?charter=NN URL prefill (survives the native contact-form markup)
   No external deps. Coral accent, no gold — visuals live in CSS.
   ===================================================================== */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var urlPrefillDone = false;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.reef-png .rv:not([data-rv-seen])');
    if (!els.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.setAttribute('data-rv-seen', '1'); e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (!en.isIntersecting) return;
        var t = en.target;
        setTimeout(function () { t.classList.add('in'); }, (i % 4) * 120);
        io.unobserve(t);
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { e.setAttribute('data-rv-seen', '1'); io.observe(e); });
  }

  function chartSelect() {
    return document.getElementById('png-mf-charter');
  }

  // Season "Enquire →" card buttons → set the select + scroll to the form.
  function bindCharterButtons(root) {
    var sel = chartSelect();
    var btns = (root || document).querySelectorAll('[data-charter]:not([data-charter-bound])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-charter-bound', '1');
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-charter');
        var s = chartSelect();
        if (s && s.querySelector('option[value="' + val + '"]')) s.value = val;
        var target = document.getElementById('reef-png-enquiry');
        if (target) target.scrollIntoView({ behavior: RM.matches ? 'instant' : 'smooth', block: 'start' });
      });
    });
    return sel;
  }

  // ?charter=NN — run once; the option values are the two-digit charter numbers.
  function urlPrefill() {
    if (urlPrefillDone) return;
    var sel = chartSelect();
    if (!sel) return;
    var m = location.search.match(/[?&]charter=(\d{1,2})/);
    if (m) {
      var v = m[1].length === 1 ? '0' + m[1] : m[1];
      if (sel.querySelector('option[value="' + v + '"]')) { sel.value = v; urlPrefillDone = true; }
    }
  }

  function init(root) {
    reveal(root);
    bindCharterButtons(root);
    urlPrefill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-init when a PNG section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    urlPrefillDone = false; // a reloaded enquiry section gets a fresh select
    init(e.target || document);
  });
})();
